import "./info-general.modal.scss";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { CircularProgress } from "@mui/material";

type LoadingGeneralModalProps = {
    isOpen: boolean;
    onClose: (v: boolean) => void;
    message: string;
    message2?: string;
    /** ไม่ให้ปิดด้วยปุ่ม X / คลิกนอก / Esc ระหว่างโหลด */
    preventDismiss?: boolean;
};

const LoadingGeneralModal = ({
    isOpen,
    onClose,
    message,
    message2,
    preventDismiss = false,
}: LoadingGeneralModalProps) => {
    const handleClose = () => {
        if (preventDismiss) return;
        onClose(false);
    };

    return (
        <Modal
            centered
            show={isOpen}
            onHide={handleClose}
            className="info-general-control"
            backdrop={preventDismiss ? "static" : true}
            keyboard={!preventDismiss}
        >
            <Modal.Body className="info-general-body">
                {!preventDismiss && (
                    <FontAwesomeIcon
                        icon={faClose}
                        className="info-general-icon-close"
                        onClick={handleClose}
                    />
                )}

                <CircularProgress className="info-general-icon-trash" />

                <p className="info-general-title">
                    {message}
                </p>

                <p className="info-general-description">
                   {message2}
                </p>
            </Modal.Body>
        </Modal>
    )
}

export default LoadingGeneralModal;